// Map definitions. Everything is a box so the greybox can change between rounds.
// x is east, y is up, z is north. Positions are box centres, sizes are half extents.
// Optional rotation in radians about each axis, applied in x, y, z order, for ramps.
const paper = "#F2F2EE";
const slate = "#9AA0B4";
const orange = "#FF7A1A";
const red = "#FF3B3B";
export const ARENA_HALF = 28;
/** The M0 box arena. Kept as the fallback map and for the replay test. */
export const ARENA_M0 = [
    { x: 0, y: -0.5, z: 0, hx: ARENA_HALF, hy: 0.5, hz: ARENA_HALF, color: paper },
    { x: 0, y: 3, z: ARENA_HALF + 0.5, hx: ARENA_HALF + 1, hy: 3, hz: 0.5, color: slate },
    { x: 0, y: 3, z: -ARENA_HALF - 0.5, hx: ARENA_HALF + 1, hy: 3, hz: 0.5, color: slate },
    { x: ARENA_HALF + 0.5, y: 3, z: 0, hx: 0.5, hy: 3, hz: ARENA_HALF + 1, color: slate },
    { x: -ARENA_HALF - 0.5, y: 3, z: 0, hx: 0.5, hy: 3, hz: ARENA_HALF + 1, color: slate },
    { x: 0, y: 3.25, z: 0, hx: 7, hy: 0.25, hz: 7, color: paper },
    { x: -6, y: 1.5, z: -6, hx: 0.5, hy: 1.5, hz: 0.5, color: slate },
    { x: 6, y: 1.5, z: -6, hx: 0.5, hy: 1.5, hz: 0.5, color: slate },
    { x: -6, y: 1.5, z: 6, hx: 0.5, hy: 1.5, hz: 0.5, color: slate },
    { x: 6, y: 1.5, z: 6, hx: 0.5, hy: 1.5, hz: 0.5, color: slate },
    { x: 9.5, y: 0.35, z: 0, hx: 1.5, hy: 0.35, hz: 2, color: orange },
    { x: 12.5, y: 1.05, z: 0, hx: 1.5, hy: 1.05, hz: 2, color: orange },
    { x: 15.5, y: 1.75, z: 0, hx: 1.5, hy: 1.75, hz: 2, color: orange },
    { x: 12, y: 3.25, z: 4.5, hx: 5, hy: 0.25, hz: 1, color: paper },
    { x: 0, y: 3.25, z: 20, hx: 4, hy: 3.25, hz: 3, color: slate },
    { x: 0, y: 1.0, z: 15, hx: 3, hy: 1.0, hz: 1.5, color: red },
    { x: -18, y: 1, z: -14, hx: 1.2, hy: 1, hz: 1.2, color: red },
    { x: -20, y: 1, z: 6, hx: 1.2, hy: 1, hz: 1.2, color: red },
    { x: 17, y: 1, z: -18, hx: 1.2, hy: 1, hz: 1.2, color: red },
    { x: 20, y: 1, z: 12, hx: 1.2, hy: 1, hz: 1.2, color: red },
    { x: -8, y: 1, z: -20, hx: 2.4, hy: 1, hz: 1.2, color: red },
    { x: 8, y: 1, z: 22, hx: 1.2, hy: 1, hz: 2.4, color: red },
    { x: -14, y: 1.25, z: 0, hx: 0.4, hy: 1.25, hz: 6, color: slate },
];
export const SPAWNS = [
    { x: -22, y: 0, z: -22, yaw: 0.8 },
    { x: 22, y: 0, z: -22, yaw: -0.8 },
    { x: -24, y: 0, z: 12, yaw: 2.2 },
    { x: 24, y: 0, z: -4, yaw: -2.0 },
    { x: -10, y: 0, z: 24, yaw: 2.8 },
    { x: 14, y: 0, z: 24, yaw: -2.8 },
];
export const ARENA_M0_MAP = {
    name: "Box Arena",
    half: ARENA_HALF,
    boxes: ARENA_M0,
    spawns: SPAWNS,
    pads: [
        { id: "P9", kind: 5, x: 0, y: 3.5, z: 0, label: "Warhead" },
        { id: "P1", kind: 3, x: 0, y: 0, z: 0, label: "Sticky" },
        { id: "P2", kind: 2, x: 0, y: 0, z: -24, label: "Impact" },
        { id: "P3", kind: 2, x: 0, y: 0, z: 10, label: "Impact" },
        { id: "P4", kind: 4, x: -20, y: 0, z: -4, label: "Bouncer" },
    ],
    waypoints: [
        { id: 0, x: -22, y: 0, z: -22, links: [{ to: 1 }, { to: 3 }] },
        { id: 1, x: 22, y: 0, z: -22, links: [{ to: 0 }, { to: 2 }] },
        { id: 2, x: 22, y: 0, z: 20, links: [{ to: 1 }, { to: 3 }, { to: 4 }] },
        { id: 3, x: -22, y: 0, z: 20, links: [{ to: 2 }, { to: 0 }, { to: 4 }] },
        { id: 4, x: 0, y: 0, z: 0, links: [{ to: 2 }, { to: 3 }, { to: 5 }, { to: 0 }, { to: 1 }] },
        { id: 5, x: 0, y: 0, z: -24, links: [{ to: 4 }, { to: 0 }, { to: 1 }] },
    ],
};
//# sourceMappingURL=map.js.map